// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".gongde-box-payment-container[data-v-187b79ac] {\n  position: absolute;\n  top: 0;\n  left: 0;\n  bottom: 0;\n  right: 0;\n  background-color: #fcf5ec;\n  background-image: url('https://fe-img.tengzhihh.com/image/54c89981c5251e5cd8996007d316e476-800x1280.png');\n  background-size: 100% 100%;\n  background-repeat: no-repeat;\n}\n", ""]);
// Exports
module.exports = exports;
